import React from 'react';
import { FcBusinessman } from 'react-icons/fc';
import './UserCard.scss';

const UserCard = () => {
  return (
    <div className="user-card-container">
      <div className="left-section">
        <div className="user-profile">
          <div className="icon-wrapper">
            <FcBusinessman size="2em" />
          </div>
          <span className="user-name">username</span>
        </div>        
        <div className="user-status">
          <span>Payment in progress</span>
        </div>
      </div>
      <div className="right-section">        
        <div className="user-service">
          <span>Contact Customer Service</span>
        </div>
        <div className="user-message">
          <span>information</span>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
